import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Środki otrzymane',
  type: 'object',

  properties: {
    date: {
      fieldRequired: true,
      format: 'date',
      title: 'Data otrzymania środków',
      type: 'string'
    }
  },

  allOf: [validationMessages]
};
